import { getClient } from '@/lib/restClient';
import { StoreManagementDeliveryStoreActivationJobsService } from '@/services/StoreManagement/DeliveryStoreActivationJobs/StoreManagementDeliveryStoreActivationJobsService';

export type StoreManagementDeliveryStoreActivationJobCreateParams = {
  delivery_store_id: string;
  integration_date: Date;
};

export const useStoreManagementDeliveryStoreActivationJobCreate = async (
  params: StoreManagementDeliveryStoreActivationJobCreateParams
): Promise<void> => {
  const storeManagementDeliveryStoreActivationJobsService =
    new StoreManagementDeliveryStoreActivationJobsService(getClient());
  return await storeManagementDeliveryStoreActivationJobsService.create(params);
};
